import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "antd/dist/antd.css";
import './assets/scss/app.scss';
import * as serviceWorker from './serviceWorker';
import { StoreProvider } from './store';


ReactDOM.render(
	<StoreProvider>
		<App />
	</StoreProvider>
, document.getElementById('root'));

// This dashboard must always pick up the latest deployed bundle. Keeping the
// CRA service worker enabled makes an older bundle remain active until every
// tab using the application has been closed.
serviceWorker.unregister();
